<template>
  <div class="home">
    <div class="container">
      <div class="left">
        <div class="has-version">
          <div class="news-info">
            <!-- <img
              :src="currentVersion?.editionImg"
              v-if="currentVersion?.editionImg"
            /> -->
            <NewspaperImageMap
              :newspaperImage="currentVersion?.editionImg"
              :articles="articleList"
              @openInfo="openInfo"
              v-if="currentVersion?.editionImg"
            />
            <NoData tip="请订阅后查看版面信息" v-else />
          </div>
          <div class="progress-box">
            <ProgressItem
              :totalVersion="totalVersion"
              :currentVersion="currentVersion"
              :currentVersionIndex="currentVersionIndex"
              @decreaseVersion="decreaseVersion"
              @increaseVersion="increaseVersion"
            />
          </div>
          <div class="news-version">
            <div class="news-title">
              {{ currentVersion?.editionName }}
              <!-- 今日要闻今日要闻要闻今日要闻今日要闻要闻今日要闻今日要闻要闻今日要闻今日要闻要闻今日要闻今日要闻要闻 -->
            </div>
            <div class="news-title">
              <el-button
                type="primary"
                size="large"
                color="#0050f3"
                class="down-btn"
                @click="downPdf"
                :disabled="hasPermission || !userStore?.isLogin"
                >下载PDF</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="mini-app">
          <img class="qr-code" :src="miniApp" />
          <div class="qr-name">
            <img class="mini-icon" :src="miniIcon" /><span>小程序二维码</span>
          </div>
        </div>
        <VersionLayout
          v-model:timeValue="timeValue"
          v-model:currentMonth="currentMonth"
          :totalVersion="totalVersion"
          :currentVersion="currentVersion"
          :currentVersionIndex="currentVersionIndex"
          :currentNews="currentNews"
          :totalPeriod="totalPeriod"
          :articleList="articleList"
          :homeRightLoading="homeRightLoading"
          :hasPermission="hasPermission"
          @changePeriod="changePeriod"
          @changeVersion="changeVersion"
          @openInfo="openInfo"
          v-if="!queryInfo.isDetail"
        />
        <DetailLayout
          :timeValue="timeValue"
          :key="$route.fullPath"
          :currentVersionName="queryInfo.currentVersionName"
          :currentNewsId="queryInfo.currentNewsId"
          :requestApi="requestApi"
          @closeInfo="closeInfo"
          v-else
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, watchEffect, h } from "vue";
import findNearestDate from "@/utils/findNearestDate";
import { ElMessage } from "element-plus";
import miniApp from "@/assets/mini_app.jpeg";
import miniIcon from "@/assets/mini_icon.png";
import { useRouter } from "vue-router";
import userInfoStore from "@/store/index";
import ProgressItem from "./components/ProgressItem.vue";
import VersionLayout from "./components/VersionLayout.vue";
import DetailLayout from "./components/DetailLayout.vue";
import NewspaperImageMap from "./components/NewspaperImageMap.vue";
import NoData from "@/components/NoData";
import api from "@/services/index";
import { code, siteId } from "@/services/config";
import dayjs from "dayjs";
import routerTree from "@/router/config";

const router = useRouter();
const userStore = userInfoStore();
const props = defineProps(["queryInfo", "currentVersion"]);
const totalPeriod = ref([]); //当前月份总期次列表
const totalVersion = ref([]); //总版次
const currentVersion = ref({}); //当前查看的版次
const currentVersionIndex = ref(1); //当前查看版面索引
const currentNews = ref({}); //当前查看的报纸详情
const currentMonth = ref(dayjs().format("YYYY-MM")); //当前月份用于查询当前月份期次列表
const timeValue = ref(""); //当前查看的默认期次，默认为当月最后一次期次
const hasPermission = ref(false); //是否有当前期次查看权限
const articleList = ref([]); //文章列表
const homeRightLoading = ref(false); //版次区域是否展示loading框
//这个需求是为了能让用户拿到相应的详情页地址，打开后直接展示详情页。原来详情页于列表的控制只是通过一个字段来控制的。由于需要通过地址进入直接展示详情内容。只能通过改动页面跳转逻辑。
const windowHost = ref(window.location.href); //获取当前浏览器地址。
const queryInfo = ref({}); //当前页面路由参数
const requestApi = ref(api.noLimitHome); //有权限时接口地址是api.home，无权限时是api.noLimitHome

//切换报纸期次
const changePeriod = (type: string) => {
  let currentTime = dayjs(timeValue.value).format("YYYY-MM-DD");
  let currentIndex = totalPeriod.value.indexOf(currentTime); // 初始日期索引
  console.log("currentIndex1", currentTime);
  console.log("currentIndex2", currentIndex);
  console.log("currentIndex3", totalPeriod.value);
  currentVersionIndex.value = 1;
  if (type == "pre") {
    if (currentIndex == 0) {
      const now = dayjs(timeValue.value);
      // 计算上个月的第一天
      const firstDayLastMonth = now.subtract(1, "month").startOf("month");
      let preTime = firstDayLastMonth.format("YYYY-MM-01");
      dateList(preTime, "pre");
      return;
    }
    currentIndex--;
    timeValue.value = totalPeriod.value[currentIndex];
  } else {
    if (timeValue.value == dayjs().format("YYYY-MM-DD")) {
      ElMessage({
        message: "当前为最新一期！",
        type: "warning",
        duration: 5000,
      });
      return;
    }
    if (currentIndex == totalPeriod.value.length - 1) {
      // 获取当前日期
      const now = dayjs(timeValue.value);
      // 计算下个月的第一天
      const firstDayNextMonth = now.add(1, "month").startOf("month");
      let nextTime = firstDayNextMonth.format("YYYY-MM-01");
      dateList(nextTime, "next");
      return;
    }
    currentIndex++;
    timeValue.value = totalPeriod.value[currentIndex];
  }
};
//切换上一版本
const decreaseVersion = () => {
  currentVersionIndex.value += 1;
  if (currentVersionIndex.value > totalVersion.value.length) {
    currentVersionIndex.value = totalVersion.value.length;
  }
};
//切换下一版本
const increaseVersion = () => {
  currentVersionIndex.value -= 1;
  if (currentVersionIndex.value < 1) {
    currentVersionIndex.value = 1;
  }
};

//切换日报版本
const changeVersion = (item: number) => {
  console.log("调用了");
  const index = totalVersion.value?.findIndex((it) => it.id == item.id);
  console.log("index.i", index);
  //索引加1是当前版次
  currentVersionIndex.value = index + 1;
};

//点击报纸标题查看详情
const openInfo = (info: Object) => {
  console.log("info", currentVersion.value);
  currentNews.value = info;
  router.push({
    path: routerTree.home,
    query: {
      isDetail: 1,
      currentNewsId: currentNews.value.id,
      currentVersionName: currentVersion.value.editionName,
      currentVersion: currentVersion.value.weight,
      timeValue: dayjs(timeValue.value).format("YYYY-MM-DD"),
    },
  });
};

//关闭详情页
const closeInfo = () => {
  queryInfo.value = {};
  router.push(routerTree.home);
};
//下载版面图pdf
const downPdf = () => {
  console.log("currentVersion", currentVersion.value);
  if (!currentVersion.value.editionImg) {
    return;
  }
  const url = currentVersion.value.editionImg.slice(0, -3) + "pdf";
  window.open(url);
};

//获取按月份返回当前报纸该月份存在的期次列表
const dateList = async (nextOrPerTime?: string, nextOrPer?: string) => {
  const params = {
    code,
    date: nextOrPerTime || dayjs(currentMonth.value).format("YYYY-MM-01"),
  };
  const res = await requestApi.value.dateList(params);
  if (res.status == 200) {
    //如果每日期次日期并且是点击切换期次按钮调用的这个方法
    if ((!res.obj.dateList || res.obj.dateList.length < 1) && nextOrPerTime) {
      ElMessage({
        message:
          "您当前的权限只能浏览到本期内容，如需浏览更多内容，请扫描右侧小程序二维码进行订阅！",
        type: "warning",
        duration: 5000,
      });
      return;
    }
    //如果这个月没有报纸期次就请求上个月的
    if (res.obj.dateList?.length < 1) {
      currentMonth.value = dayjs()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-01");
    } else {
      const sortedDates = res.obj?.dateList.sort();
      totalPeriod.value = sortedDates;
      if (totalPeriod.value?.length && !props.queryInfo?.timeValue) {
        timeValue.value =
          nextOrPerTime && nextOrPer == "next"
            ? totalPeriod.value[0]
            : totalPeriod.value[totalPeriod.value?.length - 1];
      }
    }
  }
};

//根据期次查询(无订阅也可返回，没有版面图链接)
const getNewsVersion = async () => {
  //watchEffect初始化调用时timeValue为空就不请求接口
  console.log("timeValue.value", timeValue.value);
  if (!timeValue.value) {
    return;
  }
  const params = {
    code,
    siteId,
    periodTime: dayjs(timeValue.value).format("YYYY-MM-DD"),
  };
  const res = await requestApi.value.periodTime(params);
  if (res.status == 200) {
    totalVersion.value = res.obj.editionList;
    hasPermission.value = !!!res.obj.status;
    //当前期次为板块第一个
    currentVersion.value = res.obj.editionList[0];
    console.log("totalVersion.value", totalVersion.value);
  }
};

//根据版面id返回文章列表
const getArticleList = async () => {
  if (!currentVersion.value?.id) {
    return;
  }
  const params = {
    siteId,
    id: currentVersion.value?.id,
  };
  const res = await requestApi.value.editionId(params);
  if (res.status == 200) {
    articleList.value = res.list;
  }
};
watchEffect(() => {
  getNewsVersion();
});
watchEffect(() => {
  dateList();
});

watchEffect(() => {
  if (currentVersionIndex.value) {
    //切换版次索引后就更新当前选择的版次
    currentVersion.value = totalVersion.value[currentVersionIndex.value - 1];
    console.log("currentVersion.value", currentVersion.value);
  }
});
watchEffect(() => {
  getArticleList();
});

watchEffect(() => {
  if (windowHost.value && currentNews.value.id) {
    queryInfo.value = props.queryInfo;
    console.log("queryInfo.value", queryInfo.value);
  }
});

onMounted(() => {
  const token = localStorage.getItem("token");
  console.log("currentVersionIndex.value1", props.queryInfo);

  if (token) {
    requestApi.value = api.home;
  } else {
    requestApi.value = api.noLimitHome;
  }
  if (props.queryInfo?.currentNewsId) {
    console.log("props.queryInfo", props.queryInfo);
    queryInfo.value = props.queryInfo;
    currentVersionIndex.value = props.queryInfo?.currentVersion;
    timeValue.value = props.queryInfo?.timeValue;
  }
});
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.home {
  width: 100%;
  height: calc(100vh - 4.9rem);
  overflow-y: auto;
  background: #f5f7fa;

  .container {
    width: 100%;
    min-height: 65rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 2rem 0;
    .left {
      width: 41rem;
      min-height: 65rem;
      padding: 1.2rem;
      background: linear-gradient(180deg, #bdd2ff 0%, #ffffff 100%);
      border-radius: 0.9rem;
      filter: blur(0);
      .no-version {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
      }
      .news-info {
        width: 100%;
        min-height: 52rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .progress-box {
        margin-top: 1.2rem;
      }
      .news-version {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        min-height: 3.2rem;
        margin-top: 2rem;
        padding: 0 0.8rem;
        .news-title {
          font-weight: 600;
          font-size: 1.8rem;
        }
        .down-btn {
          display: flex;
          align-items: center;
          height: 3.2rem;
          font-size: 1.4rem;
        }
      }
    }
    .right {
      position: relative;
      width: 76rem;
      height: 65rem;
      margin-left: 2rem;
      .mini-app {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 10.2rem;
        height: 14rem;
        right: -10.6rem;
        bottom: 1rem;
        .qr-code {
          width: 100%;
          height: 10.2rem;
        }
        .qr-name {
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 100%;
          height: 2.8rem;
          padding: 0 0.2rem;
          font-size: 1.2rem;
          font-weight: 600;
          border-radius: 0.8rem;
          border: 1px solid rgba(0, 0, 0, 0.08);
          img {
            width: 1.5rem;
            height: 1.5rem;
          }
        }
      }
    }
  }
}
</style>